		<!-- Dashboard start -->
				<!-- END: Left Aside -->
				<div class="m-grid__item m-grid__item--fluid m-wrapper" >
					<!-- BEGIN: Subheader -->
					<div class="m-subheader ">
						<div class="d-flex align-items-center">
						</div>
					</div>
					<!-- END: Subheader -->
					<!--MAIN-->
					<div class="m-content" >

						<ngx-spinner
							bdColor="rgba(75, 55, 100, 0.5)"
							size="large"
							color="#fff"
							type="line-scale-pulse-out">
								<span class="chevron left"></span>
								<span class="chevron right"></span>
						</ngx-spinner>

							<!--begin::Form-->
							<form [formGroup]="clientForm" class="m-form m-form--label-align-right">
								<!--begin::Portlet-->
								<div class="m-portlet" style="width: 100%">
									<div class="m-portlet__head">
										<div class="m-portlet__head-caption">
											<div class="m-portlet__head-title">
												<h3 class="m-portlet__head-text">
													USER INFORMATION 
												</h3>
											</div>
										</div>
									</div>
								<div class="m-portlet__body">
									<div class="m-form__section m-form__section--first">
									
										<div class="form-group m-form__group row">
											<label class="col-lg-4 col-form-label">
												Email:
											</label>
											<div class="col-lg-6">
												<input formControlName="userEmail"
													   type="text" id="email" 
													   class="form-control m-input">
												<span class="m-form__help" style="color:red;"
													  *ngIf="!clientForm.controls.userEmail.valid && 
													  (clientForm.controls.userEmail.dirty || 
													  clientForm.controls.userEmail.touched)">
													Please enter a valid email for this user
												</span>
											</div>
                                        </div>
                                        
										<div class="form-group m-form__group row">
											<label class="col-lg-4 col-form-label">
												Phone Number
											</label>
											<div class="col-lg-6">
												<input formControlName="userPhoneNumber"
													   type="text" id="phonenumber"
													   pattern="^[\s.]*(\d{1,2}[\s.-]*)?\(?\d{3}\)?[\s.-]*\d{3}[\s.-]*\d{4}[\s.]*$"
													   maxlength="16"
													   class="form-control m-input">
												<span class="m-form__help" >
													A valid phone number is not required, but is recommended.
												</span><br>
													<span class="m-form__help" style="color:red;"
													   *ngIf="!clientForm.controls.userPhoneNumber.valid && 
													   (clientForm.controls.userPhoneNumber.dirty || 
													   clientForm.controls.userPhoneNumber.touched)">
													Please enter a valid phone number for this user
												</span>
											</div>
                                        </div>
										
										<div class="form-group m-form__group row">

											<label class="col-lg-4 col-form-label">
													<img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" style="position: relative;" 
													tooltip="If enabled, this date range will dictate the period of time that this user can create services.">
												Subscription Period:
											</label>
											<div class="col-lg-1">
												<label class="switch">
													<input 
													id="enableSubsciptionPeriod" 
													formControlName="userEnableSubscriptionPeriod" 
													type="checkbox" class="form-control"
													(change)=toggleSubscription()>													
													<span class="slider round"></span>
												</label>
											</div>
											<div class="col-lg-4">
												<app-service-period [showTooltip]="false" [minDays]="30" formControlName="userSubscriptionPeriod"></app-service-period>			
											</div>
										</div>                               
										
										<div *ngIf="hasAllUsers" class="form-group m-form__group row">
											<label class="col-lg-4 col-form-label">
												Organization:
											</label>
											<div class="col-lg-6">
												<select [requiredIf]="hasAllUsers"
														formControlName="userOrganizationId" 
														class="col-lg-12 col-m-4 form-control m-input"
														id="organization" 
														name="organization"
														(change)="onSelectOrganization();">
													<option style="display: none;" value="null"></option>
													<option *ngFor="let org of organizations" 
															[selected]="org.organizationId === clientForm.controls.userOrganizationId.value"														
															[ngValue]="org.organizationId">
														{{org.name}}
													</option>
                                                </select>
												<span class="m-form__help" style="color:red;"
													   *ngIf="!clientForm.controls.userOrganizationId.valid && 
													   (clientForm.controls.userOrganizationId.dirty || 
													   clientForm.controls.userOrganizationId.touched)">
													Please choose an organization for this user   
												</span>
											</div>
										</div>

										<div class="form-group m-form__group row" [hidden]="clientForm.controls.userOrganizationId.value < 0 || loading">
											<label class="col-lg-4 col-form-label">
												Client Type:
											</label>
											<div class="col-lg-6">
												<select formControlName="userClientTypeId"
														class="col-lg-12 col-m-4 form-control m-input"
														id="clienttype">
													<option style="display: none;" value="null"></option>
													<option *ngFor="let type of clientTypes"
															[selected]="type.clientTypeId === clientForm.controls.userClientTypeId.value"
															[ngValue]="type.clientTypeId">
														{{type.name}} / {{type.code}}
													</option>
                                                </select>
												<span class="m-form__help" style="color:red;"
													   *ngIf="!clientForm.controls.userClientTypeId.valid && 
													   (clientForm.controls.userClientTypeId.dirty || 
													   clientForm.controls.userClientTypeId.touched)">
													Please choose a client type for this user   
												</span>
											</div>
                                        </div>                        
										
										<div *ngIf="(hasAllUsers || hasOrgUsers) && !staffUser" class="form-group m-form__group row">
											<label class="col-lg-4 col-form-label">
												Role:
											</label>
											<div class="col-lg-6">
												<select [requiredIf]="(hasAllUsers || hasOrgUsers) && !staffUser"
														formControlName="userRoleId" class="col-lg-12 col-m-4 form-control m-input"
														id="role" 
														name="role">
													<option style="display: none;" value="null"></option>
													<option style="color:black;"
															[selected]="role.roleId == clientForm.controls.userRoleId.value"
															*ngFor="let role of roles"
															[ngValue]="role.roleId">
														{{role.name}}
													</option>
                                                </select>
												<span class="m-form__help" style="color:red;"
													   *ngIf="!clientForm.controls.userRoleId.valid && 
													   (clientForm.controls.userRoleId.dirty || 
													   clientForm.controls.userRoleId.touched)">
													Please choose a role for this user   
												</span>
											</div>
										</div>	
										
										<div class="form-group m-form__group row">
											<label class="col-lg-4 col-form-label">
											  <img
												src="../../assets/app/media/img/icons/info-icon.png"
												class="tooltip-icon"
												style="position: relative;"
												tooltip="If enabled, after the user uploads a custom track he will be able to program the torches for it"
											  />
											  Can User Program Lightshows
											</label>
											<div class="col-lg-1">
											  <label class="switch">
												<input
												  id="canProgramCustomTracks"
												  formControlName="canProgramCustomTracks"
												  type="checkbox"
												  class="form-control"
												/>
												<span class="slider round"></span>
											  </label>
											</div>
										</div>
							  
										<div class="form-group m-form__group row">
											<label class="col-lg-4 col-form-label">
												<img
												src="../../assets/app/media/img/icons/info-icon.png"
												class="tooltip-icon"
												style="position: relative;"
												tooltip="If enabled, this user will be able to use the Global Sync feature"
												/>
												Can User Start Global Sync
											</label>
											<div class="col-lg-1">
												<label class="switch">
												<input
													id="enableNetworkSync"
													formControlName="enableNetworkSync"
													type="checkbox"
													class="form-control" 
												/>
												<span class="slider round"></span>
												</label>
											</div>
										</div>

										  <div class="form-group m-form__group row">
											<label class="col-lg-4 col-form-label">
											  <img
												src="../../assets/app/media/img/icons/info-icon.png"
												class="tooltip-icon"
												style="position: relative;"
												tooltip="If enabled, this user will be able to create venues and add sections to their light shows"
											  />
											  Can User Edit Venues
											</label>
											<div class="col-lg-1">
											  <label class="switch">
												<input
												  id="canEditVenues"
												  formControlName="canEditVenues"
												  type="checkbox"
												  class="form-control"
												/>
												<span class="slider round"></span>
											  </label>
											</div>
										  </div>
                                        
                                        <div class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												Notify the user via email:
											</label>
											<div class="col-lg-6">
												<label class="switch">
													<input 
													formControlName="userShouldNotify" 
													id="shouldNotifyUserCreated" 
													type="checkbox" class="form-control">
													<span class="slider round"></span>
												</label>
												
											</div>
										</div>

										<div *ngIf="environmentName !== 'production'" class="form-group m-form__group row">
											<label class="col-lg-4 col-form-label">
											  <img
												src="../../assets/app/media/img/icons/info-icon.png"
												class="tooltip-icon"
												style="position: relative;"
												tooltip="If enabled and a Yinzcam app type is selected, GitHub actions will be dispatched from the portal backend."
											  />
											  Enable GitHub Actions
											</label>
											<div class="col-lg-1">
											  <label class="switch">
												<input
												  id="enableGitHubActions"
												  formControlName="enableGitHubActions"
												  type="checkbox"
												  class="form-control"
												/>
												<span class="slider round"></span>
											  </label>
											</div>
										  </div>
										
									</div> <!--end::Portlet-->
								</div>
							</div>
							<div class="m-portlet" style="width: 100%">
								<div class="m-portlet__head">
									<div class="m-portlet__head-caption">
										<div class="m-portlet__head-title">
											<h3 class="m-portlet__head-text">
												ENGINE INFORMATION 
											</h3>
										</div>
									</div>
								</div>
								<div class="m-portlet__body">
									<div class="m-form__section m-form__section--second">

										<div class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												Application Name: 
											</label>
											<div class="col-lg-6">
												<input
													class="form-control m-input" 
													formControlName="engineApplicationName"
													type="text"
													(input)="preventWhiteSpace(formControls('engineApplicationName'))"
													(change)="applicationNameChange()"/>	
												<span class="m-form__help" style="color:red;"
													*ngIf="!clientForm.controls.engineApplicationName.valid && 
													(clientForm.controls.engineApplicationName.dirty || 
													clientForm.controls.engineApplicationName.touched)">
												Please enter a valid application name for this engine
												</span>	
											</div>
										</div>

										<div class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												API Key: 
											</label>
											<div class="col-lg-6">
												<input
													class="form-control m-input" 
													formControlName="engineApiKey"
													type="text"/>
												<button 
													type="button" 
													class="btn btn-info"
													(click)="generateApiKey()">
													Auto Generate
												</button>	
												<span class="m-form__help" style="color:red; padding-left: 1em;"
													*ngIf="!clientForm.controls.engineApiKey.valid && 
													(clientForm.controls.engineApiKey.dirty || 
													clientForm.controls.engineApiKey.touched)">
												Please enter a valid API Key for this engine
												</span>	
											</div>
										</div>

										<div class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
													Config:
											</label>
											<div class="col-lg-6">
												<select
													class="col-lg-12 col-m-4 form-control m-input"
													id="configs"
													formControlName="engineConfigId"
													[compareWith]="compare" 
													name="configs">
														<option *ngFor="let c of configs" [ngValue]="c.cueConfigId">
															{{c.name}}
														</option>
												</select>
												<br>
												<span class="m-form__help" style="color:red; position:absolute; top:50%;"
													*ngIf="!clientForm.controls.engineConfigId.valid && 
													(clientForm.controls.engineConfigId.dirty || 
													clientForm.controls.engineConfigId.touched)">
													Please enter a valid config for this engine
												</span>																						
												
											</div>
										</div>

										<div class="form-group m-form__group row" >
												<label class="col-lg-4 col-form-label">
													Notes:
												</label>
												<div class="col-lg-6">
														<input
														class="form-control m-input" 
														formControlName="engineNotes"
														type="text"/>						
											
												</div>
										</div>

										<div class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												Image segment start time threshold (seconds):
											</label>
											<div class="col-lg-6">
													<input
													class="form-control m-input" 
													formControlName="imageSegmentStartTimeThreshold"
													type="number"
													min="0"
													max="60"/>	
												<br>
												<span class="m-form__help" style="color:red; position:absolute; top:50%;"
													*ngIf="!clientForm.controls.imageSegmentStartTimeThreshold.valid && 
													(clientForm.controls.imageSegmentStartTimeThreshold.dirty || 
													clientForm.controls.imageSegmentStartTimeThreshold.touched)">
													Please enter a value between 0 and 60
												</span>						
										
											</div>
									</div>

										<div class="form-group m-form__group row" >
												<label class="col-lg-4 col-form-label">
														Available Service Types:
												</label>
												<div class="col-lg-6">
													<ul style="list-style-type: none;">
														<li *ngFor="let type of serviceTypes" >
															<span>{{type.formattedName}} </span>
															<input 
															id="serviceTypeCheckBox" 
															style="padding-left: 5px; vertical-align: middle; text-align: center;"
															[checked]="selectedServiceTypeIds.indexOf(type.serviceTypeId) > -1"
															type="checkbox"
															(change)="toggleServiceTypeSelect(type.serviceTypeId);" >
														</li>
													</ul>
												</div>
										</div>

										<div class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												Generate Demo Services:
											</label>
											<div class="col-lg-6">													
												<input style="vertical-align:middle;" 
												formControlName="engineGenerateDemoServices" 
												type="checkbox" />
											</div>
										</div>

									</div>
								</div>
							</div>
							<div class="m-portlet" style="width: 100%">
								<div class="m-portlet__head">
									<div class="m-portlet__head-caption">
										<div class="m-portlet__head-title">
											<h3 class="m-portlet__head-text">
												APP INFORMATION 
											</h3>
										</div>
									</div>
								</div>
								<div formGroupName="app" class="m-portlet__body">
									<div class="m-form__section m-form__section--second">

										<div class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												App Type: 
											</label>
											<div class="col-lg-6">
												<select
													class="col-lg-12 col-m-4 form-control m-input"
													id="appType"
													formControlName="appType"
													[compareWith]="compare" 
													name="appType"
													(change)="onAppTypeChange()">
														<option [ngValue]="-1">
															-- Select an App Type --
														</option>
														<option [ngValue]="0">
															SDK
														</option>
														<option [ngValue]="1">
															Custom App
														</option>
														<option [ngValue]="2">
															Yinzcam
														</option>
												</select>
												<app-validation-display 
                  				[control]="formControls('app').controls.appType" 
                  				errorMessage="Please select a valid App Type.">
                				</app-validation-display>
											</div>
										</div>

										<div *ngIf="formControls('app').controls.appType.value === 1 || formControls('app').controls.appType.value === 2" class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												Display Name: 
											</label>
											<div class="col-lg-6">
												<input
													class="form-control m-input" 
													formControlName="displayName"
													type="text"/>	
												<app-validation-display 
                  				[control]="formControls('app').controls.displayName" 
                  				errorMessage="Please a valid display name.">
                				</app-validation-display>
											</div>
										</div>
										
										<div *ngIf="formControls('app').controls.appType.value === 1" class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												iOS Account Developer Name 
											</label>
											<div class="col-lg-6">
												<input
													class="form-control m-input" 
													formControlName="iosDeveloperAccountName"
													type="text"
													(input)="preventWhiteSpace(formControls('app').controls.iosDeveloperAccountName)"/>	
												<app-validation-display 
                  				[control]="formControls('app').controls.iosDeveloperAccountName" 
                  				errorMessage="Please a valid developer account name.">
                				</app-validation-display>
											</div>
										</div>

										<div *ngIf="formControls('app').controls.appType.value === 2" class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												Android Version:
											</label>
											<div class="col-lg-6">
												<div style="display: flex; align-items: flex-end;">
													<input
														style="text-align: right; width: 50%;"
														class="form-control m-input" 
														formControlName="androidVersion"
														type="text"
														placeholder="0"/>	
												</div>
												<span class="m-form__help" >
													Latest Android Version: {{ latestAndroidVersion }}
												</span>
												<app-validation-display 
                  				[control]="formControls('app').controls.androidVersion" 
                  				errorMessage="A new version tag is required.">
                				</app-validation-display>
											</div>
										</div>

										<div *ngIf="formControls('app').controls.appType.value === 2" class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												iOS Version:
											</label>
											<div class="col-lg-6">
												<div style="display: flex; align-items: flex-end;">
													<input
														style="text-align: right; width: 50%;"
														class="form-control m-input" 
														formControlName="iosVersion"
														type="text"
														placeholder="0"/>	
												</div>
												<span class="m-form__help" >
													Latest iOS Version: {{ latestIosVersion }}
												</span>
												<app-validation-display 
                  				[control]="formControls('app').controls.iosVersion" 
                  				errorMessage="A new version tag is required.">
                				</app-validation-display>
											</div>
										</div>

										<div class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												Header Image: 
											</label>
											<div class="col-lg-6">
												<input
												  class="form-control m-input" 
												  type="file"
												  accept="image/png"
												  (change)="uploadHeaderImage($event.target.files[0])"
													/>
												<img 
												  *ngIf="formControls('app').controls.headerImageUrl.value !== ''" 
												  alt="" 
												  [src]="formControls('app').controls.headerImageUrl.value" 
												  style="display: block;"
												  width="512"
												  height="512"
												>	
												<span 
												  onselectstart="return false" 
												  class="img-text" 
												  style="display: block;">
													It's recommended that the image be less than 200KB in size.
												</span>
												<app-validation-display 
													*ngIf="formControls('app').controls.headerImageUrl.errors?.required"
                  				[control]="formControls('app').controls.headerImageUrl" 
                  				errorMessage="This image is required.">
                				</app-validation-display>
												<app-validation-display
													*ngIf="formControls('app').controls.headerImageUrl.errors?.incorrectFile" 
                  				[control]="formControls('app').controls.headerImageUrl" 
                  				errorMessage="The image must be a .png file.">
                				</app-validation-display>
											</div>
										</div>
										<div *ngIf="formControls('app').controls.appType.value === 1" class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												Launch Screen Foreground Image (iOS): 
											</label>
											<div class="col-lg-6">
												<input
												  class="form-control m-input" 
												  type="file"
												  accept="image/png"
												  (change)="uploadLaunchScreenForegroundImage($event.target.files[0])"
													/>	
												<img 
												  *ngIf="formControls('app').controls.launchScreenForegroundUrl.value !== ''" 
												  alt="" 
												  [src]="formControls('app').controls.launchScreenForegroundUrl.value" 
												  style="display: block;"
												  width="512"
												  height="512"
												>	
												<span 
												  onselectstart="return false" 
												  class="img-text" 
												  style="display: block;">
													Image must have exact dimensions of 1080x1920 pixels.
												</span>
												<app-validation-display 
													*ngIf="formControls('app').controls.launchScreenForegroundUrl.errors?.required"
                  				[control]="formControls('app').controls.launchScreenForegroundUrl" 
                  				errorMessage="This image is required.">
                				</app-validation-display>
												<app-validation-display
													*ngIf="formControls('app').controls.launchScreenForegroundUrl.errors?.incorrectFile" 
                  				[control]="formControls('app').controls.launchScreenForegroundUrl" 
                  				errorMessage="This image must be a .png file and have exact dimenions of 1080px in width and 1920px in height.">
                				</app-validation-display>
											</div>
										</div>
										<div *ngIf="formControls('app').controls.appType.value === 1" class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												Launch Screen Background Image (iOS): 
											</label>
											<div class="col-lg-6">
												<input
												  class="form-control m-input" 
												  type="file"
												  accept="image/jpeg"
												  (change)="uploadLaunchScreenBackgroundImage($event.target.files[0])"
													/>
												<img 
												  *ngIf="formControls('app').controls.launchScreenBackgroundUrl.value !== ''" 
												  alt="" 
												  [src]="formControls('app').controls.launchScreenBackgroundUrl.value" 
												  style="display: block;"
												  width="512"
												  height="512"
												>	
												<span 
												  onselectstart="return false" 
												  class="img-text" 
												  style="display: block;">
													Image must have exact dimensions of 1080x1920 pixels.
												</span>
												<app-validation-display 
													*ngIf="formControls('app').controls.launchScreenBackgroundUrl.errors?.required"
                  				[control]="formControls('app').controls.launchScreenBackgroundUrl" 
                  				errorMessage="This image is required.">
                				</app-validation-display>
												<app-validation-display 
													*ngIf="formControls('app').controls.launchScreenBackgroundUrl.errors?.incorrectFile"
                  				[control]="formControls('app').controls.launchScreenBackgroundUrl" 
                  				errorMessage="This image must be a .jpg file and have exact dimensions of 1080px in width and 1920px in height.">
                				</app-validation-display>
											</div>
										</div>
										<div *ngIf="formControls('app').controls.appType.value === 1" class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												iOS App Icon: 
											</label>
											<div class="col-lg-6">
												<input
													class="form-control m-input" 
													type="file"
													accept="image/png"
													(change)="uploadIosAppIconImage($event.target.files[0])"
													/>
												<img 
												  *ngIf="formControls('app').controls.iosAppIconUrl.value !== ''" 
												  alt="" 
												  [src]="formControls('app').controls.iosAppIconUrl.value" 
												  style="display: block;"
												  width="512"
												  height="512"
												>	
												<span 
													onselectstart="return false" 
													class="img-text" 
													style="display: block;">
														Image must have exact dimensions of 1024x1024 pixels.
												</span>
												<app-validation-display 
													*ngIf="formControls('app').controls.iosAppIconUrl.errors?.required"
                  				[control]="formControls('app').controls.iosAppIconUrl" 
                  				errorMessage="This image is required.">
                				</app-validation-display>
												<app-validation-display 
													*ngIf="formControls('app').controls.iosAppIconUrl.errors?.incorrectFile"
                  				[control]="formControls('app').controls.iosAppIconUrl" 
                  				errorMessage="The image must be a .png file and have exact dimensions of 1024px in width and 1024px in height.">
                				</app-validation-display>
											</div>
										</div>
										<div *ngIf="formControls('app').controls.appType.value === 1" class="form-group m-form__group row" >
											<label class="col-lg-4 col-form-label">
												Android App Icon: 
											</label>
											<div class="col-lg-6">
											  <input
												class="form-control m-input" 
												type="file"
												accept="image/png"
												(change)="uploadAndroidAppIconImage($event.target.files[0])"
											  />
												<img 
												  *ngIf="formControls('app').controls.androidAppIconUrl.value !== ''" 
												  alt="" 
												  [src]="formControls('app').controls.androidAppIconUrl.value" 
												  style="display: block;"
												  width="512"
												  height="512"
												>	
											  <span 
												onselectstart="return false" 
												class="img-text" 
												style="display: block;">
													Image must have exact dimensions of 512x512 pixels.
											  </span>
												<app-validation-display 
													*ngIf="formControls('app').controls.androidAppIconUrl.errors?.required"
                  				[control]="formControls('app').controls.androidAppIconUrl" 
                  				errorMessage="This image is required.">
                				</app-validation-display>
												<app-validation-display 
													*ngIf="formControls('app').controls.androidAppIconUrl.errors?.incorrectFile"
                  				[control]="formControls('app').controls.androidAppIconUrl" 
                  				errorMessage="The image must be a .png file and have exact dimensions of 512px in width and 512px in height.">
                				</app-validation-display>
											</div>
										</div>
										

									</div>
								</div>
							</div>
							<div class="m-portlet" style="width: 100%">
								<div class="m-portlet__head">
									<div class="m-portlet__head-caption">
										<div class="m-portlet__head-title">
											<h3 class="m-portlet__head-text">
												APP CONFIG
											</h3>
										</div>
									</div>
								</div>
								<app-visual-json-editor
									#jsonEditor
									[(objectName)]="appConfigFileName" 
									[setJson]="appConfigObj"
									[setRestrictedKeyValuePairs]="appConfigObj"
									(outputJson)="outputJson = $event"
									[showTopKeyValues]="3"
									[disableObjectName]="true"
									[showPreview]="false"
								>

								</app-visual-json-editor>
							</div>
						</form>
						
						<div class="form-group m-form__group row">
							<div class="col-lg-6">
								<div class="col-lg-8">
									<button [disabled]="loading" type="button" class="btn btn-info"
									(click)="submitNewClient()" >
										<span>Submit New Client</span>
									</button>
								</div>
							</div>
						</div>
					</div>	
				</div>

				

							
				 
